export const config = {
  collection: {
    url: "https://sit.freight.qantas.com"
    //url: "http://colltion.release.sit.a245-28.ams13.nonp.qcpaws.qantas.com.au"
  },
  customer: {
    url: "https://sit.freight.qantas.com"
    //url: "http://domcust.release.sit.a245-21.ams13.nonp.qcpaws.qantas.com.au"
  },
  dombook: {
    url: "https://sit.freight.qantas.com"
    //url: "http://dombook.release.sit.a245-27.ams13.nonp.qcpaws.qantas.com.au"
  },
  flight: {
    url: "https://sit.freight.qantas.com"
    //url: "http://flight.release.sit.a245-22.ams13.nonp.qcpaws.qantas.com.au"
  },
  refdata: {
    url: "https://sit.freight.qantas.com"
    //url: "http://refdata.release.sit.a245-22.ams13.nonp.qcpaws.qantas.com.au"
  },
  userprof: {
    url: "https://sit.freight.qantas.com"
    //url: "http://userprof.release.sit.a245-20.ams13.nonp.qcpaws.qantas.com.au"
  },
  userreg: {
    url: "https://sit.freight.qantas.com"
    //url: "http://userreg.release.sit.a245-20.ams13.nonp.qcpaws.qantas.com.au"
  },
  gha: {
    url: "https://sit.freight.qantas.com"
    //url: "http://userreg.release.sit.a245-20.ams13.nonp.qcpaws.qantas.com.au"
  },
  prdtcom: {
    url: "https://sit.freight.qantas.com"
    //url: "http://prdtcom.release.sit.a245-22.ams13.nonp.qcpaws.qantas.com.au"
  },
  track: {
    url: "https://sit.freight.qantas.com"
    //url: "http://tracking.release.sit.a245-34.ams13.nonp.qcpaws.qantas.com.au"
  },
  intlbook: {
    url: "https://sit.freight.qantas.com"
    //url: "http://intlbook.release.sit.a245-42.ams13.nonp.qcpaws.qantas.com.au"
  },
  shakedown: {
    url: "https://sit.freight.qantas.com"
    //url: "http://intlbook.release.sit.a245-42.ams13.nonp.qcpaws.qantas.com.au"
  },
  //common
  // user + tools
  login: {
    url: "https://sit.freight.qantas.com/login.html"
  },

  // user + bookings
  startbooking: {
    url: "https://freight.qantas.com"
  },
  // bookings + tools
  aircraft: {
    url: 'https://sit.freight.qantas.com/freight-planning/fleet.html'
  },

  //user widgets
  terms: {
    url: 'http://www.qantas.com/travel/airlines/terms-of-use/global/en'
  },
  policy: {
    url: 'http://www.qantas.com/travel/airlines/privacy/global/en'
  },

  //booking widgets
  express: {
    url: "https://freight.qantas.com/freight-services/air-freight/express.html"
  },
  priority: {
    url: "https://freight.qantas.com/freight-services/air-freight/priority.html"
  },
  fresh: {
    url: "https://freight.qantas.com/freight-services/custom-freight-specialty/fresh-food-transport.html"
  },
  carriagecondition: {
    url: "https://freight.qantas.com/conditions-of-carriagedomestic.html"
  },
  privacysecurity: {
    url: "https://www.qantas.com/au/en/support/privacy-and-security.html"
  },
  qbrjoin: {
    url: "https://www.qantasbusinessrewards.com/join"
  },
  qbrpoints: {
    url: "https://www.qantasbusinessrewards.com/earn-points"
  },
  freqflyertc: {
    url: "https://www.qantas.com/au/en/frequent-flyer/discover-and-join/terms-and-conditions.html"
  },
  isqbrenabled: true,
  qpp: {
    url: "https://test.qantas.com/qfqppui/qepp.js"
  },
  managebooking: {
    url: "https://sit.freight.qantas.com/manage-booking.html"
  },

  //widget tools
  retailbook: {
    url: "https://sit.freight.qantas.com/get-a-quote.html"
  },
  pets: {
    url: "https://sit.freight.qantas.com/freight/products/accompaniedpets/makebooking?channel=QFEH"
  },
  search: {
    url: 'https://sit.freight.qantas.com/search-results.search-results.json'
  },
  myfreight: {
      url: "https://freight.qantas.com"
  },
  //widget tracking
  onlinetrack: {
    url: "/standalone/online-tracking.html"
  },
  contactus: {
    url: "http://www.qantas.com.au/qfreight/qfe/customer-service-center/global/en"
  },
  shakedown: {
    url: "https://sit.freight.qantas.com"
    //url: "http://intlbook.release.sit.a245-42.ams13.nonp.qcpaws.qantas.com.au"
  },
  intlbookserverless: {
    url: "https://sit.freight.qantas.com"
    //url: "http://internal-freight-nonprod-SharedIntALB-1528388960.ap-southeast-2.elb.amazonaws.com"
  },
  retailbookingserverless: {
    url: "https://sit.freight.qantas.com"
  },
  sit: {
    url: "https://sit.freight.qantas.com"
  }
};